const styles = {
  container: {
    display: "flex",
    gap: 5,
    background: "#E6E6E6",
    borderRadius: 5,
    alignItems: "center",
    padding: "5px 5px 5px 8px",
    maxHeight: 32,
  },
  disabled: {
    pointerEvents: "none",
    opacity: 0.5,
  },
  label: {
    fontWeight: 300,
    fontSize: 8,
    color: "#171717",
  },
  value: {
    fontWeight: 500,
    fontSize: 12,
    lineHeight: "14px",
    textTransform: "capitalize",
    color: "#000000",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 200,
  },
  left: {
    display: "flex",
    flexDirection: "column",
  },
  right: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
};

export default styles;
